module.exports = __webpack_public_path__ + "static/VG5000-Regular_web-fa964cc046d072f4a7164291e6f60f73.woff";